/**
 * Identifying deserialized Coral exceptions.
 *
 * Kept free of app imports so both the API layer and AuthService can use it: AuthService is
 * imported by the client factories, so a helper living alongside the API calls would close a cycle.
 */

/**
 * Type name of a deserialized Coral exception, or '' when the value is not one.
 *
 * The exception's class carries a static, minify-safe `fullyQualifiedTypeName`; `name`, `status`
 * and `__type` are undefined or mangled on these objects. The `body` branch defensively covers a
 * CoralResponse-wrapper shape.
 */
export const coralTypeName = (err: any): string =>
    err?.constructor?.fullyQualifiedTypeName ??
    err?.body?.constructor?.fullyQualifiedTypeName ??
    ''

/**
 * True when `err` is the named Coral exception, matched on its simple name.
 *
 * Compares the segment after `#` exactly rather than substring-matching the qualified name, so a
 * shorter name can never match a longer one: `NotFoundException` must not answer true for a
 * ResourceNotFoundException, since only the latter means "not in this cell" to the cross-cell search.
 */
export const isCoralException = (err: any, simpleName: string): boolean =>
    coralTypeName(err).split('#').pop() === simpleName
